module.exports = __webpack_public_path__ + "media/icons/favourite-on@2x-f01d3ac0.png";